const PLACEHOLDER_CLIENT_IDS = new Set(["stub-client-id", "your-client-id", "changeme"])

export interface MsalAuthFields {
  clientId?: string
  authority?: string
}

export function isPopulatedMsalAuth(auth: MsalAuthFields | null | undefined): boolean {
  if (!auth) return false
  const clientId = (auth.clientId ?? "").trim()
  const authority = (auth.authority ?? "").trim()
  if (!clientId) return false
  const lowered = clientId.toLowerCase()
  if (PLACEHOLDER_CLIENT_IDS.has(lowered) || lowered.startsWith("stub-")) return false
  if (!authority) return false
  // A tenant-less authority (e.g. ".../common" only) still works for MSAL,
  // but a bare "https://login.microsoftonline.com/" with no tenant id does not. Use proper
  // URL parsing rather than substring-matching the host (which CodeQL flags as incomplete
  // URL sanitization).
  try {
    const parsed = new URL(authority)
    if (
      parsed.hostname === "login.microsoftonline.com" &&
      parsed.pathname.replace(/\/+/g, "") === ""
    ) {
      return false
    }
  } catch {
    return false
  }
  return true
}
